import React from "react";
import { BilingualField, Panel, Repeater, TextField, Toggle } from "@/components/studio/Fields";

/* The owner's other work. A video link is turned into an embed by the same
   parser the blog uses, so pasting a YouTube URL here does the right thing
   without a second field explaining what kind of link it is. */

export const PortfolioPanel = ({ draft, set }) => {
  const portfolio = draft.portfolio || {};
  const items = portfolio.items || [];

  return (
    <Panel
      title="Portfolio"
      hint="Ce que vous montrez de vous, sous l’argumentaire du produit. Une carte peut porter une image, une vidéo, un lien — ou rien de tout cela, et rester du texte."
    >
      <BilingualField
        label="Titre de la section"
        value={portfolio.title}
        onChange={(value) => set("portfolio.title", value)}
        testId="portfolio-title"
      />
      <BilingualField
        label="Introduction"
        value={portfolio.intro}
        onChange={(value) => set("portfolio.intro", value)}
        rows={2}
        testId="portfolio-intro"
      />

      <div className="mt-6">
        <Repeater
          items={items}
          onChange={(next) => set("portfolio.items", next)}
          blank={() => ({
            title: "",
            summary: { fr: "", en: "" },
            url: "",
            image_url: "",
            embed_url: "",
            year: "",
            tags: [],
            visible: true,
          })}
          addLabel="Ajouter une réalisation"
          testId="portfolio-items"
          renderItem={(item, patch) => (
            <>
              <TextField
                label="Titre"
                value={item.title}
                onChange={(value) => patch({ title: value })}
                testId={`portfolio-item-title-${item.id || "new"}`}
              />
              <BilingualField
                label="Description"
                value={item.summary}
                onChange={(value) => patch({ summary: value })}
                rows={3}
                testId={`portfolio-item-summary-${item.id || "new"}`}
              />
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <TextField
                  label="Lien"
                  hint="La carte devient cliquable. Laissez vide si la réalisation n’a pas de page."
                  value={item.url}
                  onChange={(value) => patch({ url: value })}
                  placeholder="https://…"
                  testId={`portfolio-item-url-${item.id || "new"}`}
                />
                <TextField
                  label="Année"
                  value={item.year}
                  onChange={(value) => patch({ year: value })}
                  placeholder="2026"
                  testId={`portfolio-item-year-${item.id || "new"}`}
                />
                <TextField
                  label="Image"
                  value={item.image_url}
                  onChange={(value) => patch({ image_url: value })}
                  placeholder="https://…"
                  testId={`portfolio-item-image-${item.id || "new"}`}
                />
                <TextField
                  label="Vidéo intégrée"
                  hint="Adresse d’intégration YouTube ou Vimeo. Elle remplace l’image."
                  value={item.embed_url}
                  onChange={(value) => patch({ embed_url: value })}
                  placeholder="https://www.youtube-nocookie.com/embed/…"
                  testId={`portfolio-item-embed-${item.id || "new"}`}
                />
              </div>
              <TextField
                label="Étiquettes"
                hint="Séparées par des virgules."
                value={(item.tags || []).join(", ")}
                onChange={(value) =>
                  patch({
                    tags: value
                      .split(",")
                      .map((tag) => tag.trim())
                      .filter(Boolean),
                  })
                }
                testId={`portfolio-item-tags-${item.id || "new"}`}
              />
              <Toggle
                label="Visible sur le site"
                checked={item.visible !== false}
                onChange={(value) => patch({ visible: value })}
                testId={`portfolio-item-visible-${item.id || "new"}`}
              />
            </>
          )}
        />
      </div>
    </Panel>
  );
};

export default PortfolioPanel;
